'use client'

import { usePathname } from 'next/navigation'

import { getUnlocalizedPath } from '@src/i18n/locale.util'

export function useUnlocalizedPathname() {
  const pathname = usePathname()
  return getUnlocalizedPath(pathname)
}
